module.exports = __webpack_public_path__ + "static/img/10.2465129.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/eng/10.png
// module id = F7vd
// module chunks = 0